var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5328_4376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 3.33333C6.66663 2.97971 6.8071 2.64057 7.05715 2.39052C7.3072 2.14048 7.64634 2 7.99996 2C8.35358 2 8.69272 2.14048 8.94277 2.39052C9.19282 2.64057 9.33329 2.97971 9.33329 3.33333C10.0989 3.69535 10.7516 4.25888 11.2213 4.96353C11.6911 5.66818 11.9603 6.48738 12 7.33333V9.33333C12.0501 9.7478 12.1969 10.1447 12.4285 10.4921C12.6601 10.8395 12.97 11.1276 13.3333 11.3333H2.66663C3.02992 11.1276 3.33983 10.8395 3.57142 10.4921C3.803 10.1447 3.94979 9.7478 3.99996 9.33333V7.33333C4.03967 6.48738 4.30883 5.66818 4.77859 4.96353C5.24836 4.25888 5.90102 3.69535 6.66663 3.33333",
    stroke: "#9D9D9D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11.3333V11.9999C6 12.5304 6.21071 13.0391 6.58579 13.4141C6.96086 13.7892 7.46957 13.9999 8 13.9999C8.53043 13.9999 9.03914 13.7892 9.41421 13.4141C9.78929 13.0391 10 12.5304 10 11.9999V11.3333",
    stroke: "#9D9D9D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5328_4376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertas);
export default __webpack_public_path__ + "static/media/alertas.e68a17f64b2ab92ffaf95255afa84499.svg";
export { ForwardRef as ReactComponent };